import { useEffect, useRef } from "react";

const SHOW_SECTION = "draft-section-show";

// Shows a drafted section in the Report, while it's on screen: the chat's
// "Copy a section" asks for it by the marker the server says it's at, none
// when it isn't in the Report.
export const showDraftSection = (marker: number | null | undefined) => {
  if (marker == null) return;
  window.dispatchEvent(new CustomEvent(SHOW_SECTION, { detail: marker }));
};

// While `enabled`, `show` takes each section asked for.
export const useShowDraftSection = (
  enabled: boolean,
  show: (marker: number) => void,
) => {
  const showRef = useRef(show);
  showRef.current = show;

  useEffect(() => {
    if (!enabled) return;
    const listener = (event: Event) => {
      showRef.current((event as CustomEvent<number>).detail);
    };
    window.addEventListener(SHOW_SECTION, listener);
    return () => window.removeEventListener(SHOW_SECTION, listener);
  }, [enabled]);
};
